export class MarketplaceKeywordTranslation {
    id: number;
    locale: string;
    name: string;
}
